import React, { useMemo } from "react";
import ChartComponent from "@components/ChartComponent";
import { ErrorBoundary } from "react-error-boundary";
import BoundaryFallback from "@components/ErrorBoundaryComponent";
import Store from "../ChartComponent/store";
import { useTranslation } from "react-i18next";
import {
  DASHBOARD_SLOT_CONFIG,
  FILTER_MIN_HEIGHT,
} from "./constants";

const DashboardChart = ({ slotId, editMode, editModeSlot }) => {
  const { t: translate } = useTranslation();
  const config = DASHBOARD_SLOT_CONFIG[slotId];

  const chartComponent = useMemo(
    () =>
      editMode ? (
        editModeSlot(slotId, config.translationKey)
      ) : (
        <ErrorBoundary FallbackComponent={BoundaryFallback}>
          <ChartComponent
            title={translate(config.translationKey)}
            ChartTag={config.chartTag}
            ChartTypeTag={config.chartTypeTag}
            ScaleTag={config.scaleTag}
            maxSeriesPerPage={5}
            uniqueID={config.uniqueID}
            myStore={new Store()}
            dynamicFilterTag={config.dynamicFilterTag}
            filterMinHeight={FILTER_MIN_HEIGHT}
          />
        </ErrorBoundary>
      ),
    [editMode]
  );

  return chartComponent;
};

export default DashboardChart;
